import { useEffect, useState } from "react";

export function useAfterViewTransition(): boolean {
  const [finished] = useState(() => document.activeViewTransition?.finished);
  const [ready, setReady] = useState(!finished);

  useEffect(() => {
    if (!finished) return;
    let mounted = true;
    const complete = () => {
      if (mounted) setReady(true);
    };
    // The router reports update failures; either settlement releases deferred work.
    void finished.then(complete, complete);
    return () => {
      mounted = false;
    };
  }, [finished]);

  return ready;
}
